/* istanbul ignore file */
export enum ContactLensAttributes {
  NAME_FRIENDLY = 'NAME_FRIENDLY',
  DIMENSION_SPHERE = 'DIMENSION_SPHERE',
  DIMENSION_CYLINDER = 'DIMENSION_CYLINDER',
  DIMENSION_AXIS = 'DIMENSION_AXIS',
  DIMENSION_BASE = 'DIMENSION_BASE',
  DIMENSION_DIAMETER = 'DIMENSION_DIAMETER',
  DIMENSION_ADD = 'DIMENSION_ADD',
}
